<sync-dialog
  [open]="open"
  [onClose]="onCancel"
  [config]="{
    title: 'Attention: Plan Change Pending',
    cancelButton: 'Cancel',
    onCancelClick: onCancel,
    actionButton: 'Continue',
    onActionClick: onContinue,
    closeIcon: 'close',
    onCloseIcon: onCancel,
  }"
>
  <div>You have a plan change pending that requires you maintain a single user on your account.</div>
  <div>
    If you invite or purchase more users your plan change request will be cancelled. You'll continue to be billed for
    your current accounts and users.
  </div>
</sync-dialog>
